import { SourceItem } from "../../shared/models/source-item.model";
import { CallbackButton } from "./CallbackButton";
import { useSiteContext } from "../../state/SiteContext";
import { loadCart } from "../../utils/cart.utils";
import { useMemo } from "react";
import { services } from "../../globals";

interface DownloadCartProps {
    indexfile: string,
    wrapperfile: string,
}

/***
 * Displays a download cart.
 * The cart shows a list of all files that will be downloaded when the user clicks the download button,
 * and a download button.
 * This component is currently an exception to the rule that all HTML content are provided by the
 * customer. It may be refactored in the future.
 */
export function DownloadCart({ indexfile, wrapperfile }: DownloadCartProps): React.ReactElement {
    const { siteState } = useSiteContext();

    // const getStateForItem = (item: SourceItem): State => {
    //     const itemState: State = {};
    //     (itemState as FileState).path = item.value.toString();
    //     (itemState as FilterState).systemProperties = { ...item.props.system };
    //     delete (itemState as FilterState).systemProperties?.["path"];
    //     delete (itemState as FilterState).systemProperties?.["title"];
    //     (itemState as FilterState).validity = item.props.other?.validityFilter?.[0]?.toString() || "";
    //     return itemState;
    // }

    const validityProps: Array<string> = [];
    const systemProps: Array<string> = [];

    const cart = useMemo(() => {
        return loadCart(siteState.site?.name || "");
    }, [siteState.site?.name]);

    for (let item of cart) {
        const systemPropNames = Object.keys(item.props.system || {});
        for (let systemPropName of systemPropNames) {
            if (!systemProps.includes(systemPropName)) {
                systemProps.push(systemPropName);
            }
        }
        const validityPropNames = Object.keys(item.props.validity || {});
        for (let validityPropName of validityPropNames) {
            if (!validityProps.includes(validityPropName)) {
                validityProps.push(validityPropName);
            }
        }
    }

    const columns: Array<{ label: string, id: string, classExtensions: Array<string>, renderCell: (item: SourceItem) => string | JSX.Element }> = [
        {
            label: 'Path',
            id: "system-path",
            classExtensions: ["path"],
            renderCell: (item: SourceItem) => {
                // const itemState: ComponentState = getStateForItem(item);
                // const query = getStateAsLocationQuery(itemState).toString();
                // const urlQueryStr = query ? "?" + query : "";
                return <a href="about:blank">{item.value.toString()}</a>
                // return <a href={services.file.getAppLink(siteState.sitePath || "", item.value.toString(),
                //     item.props.other.validityFilter?.[0]?.toString() || "",
                //     item.props.system,
                //     item.props.other.lang?.[0]?.toString() || "") + urlQueryStr}>{item.value.toString()}</a>
            }
        },
        {
            label: 'Title',
            id: "system-title",
            classExtensions: ["title"],
            renderCell: (item: SourceItem) => item.props.system?.title?.[0]?.toString() || "",
        },
        ...systemProps.filter(propName => { return (propName !== "path" && propName !== "title") }).map(
            propName => ({
                label: `${propName}`,
                id: "system-" + propName,
                classExtensions: ["property", "property_" + propName],
                renderCell: (item: SourceItem) => item.props.system?.[propName]?.[0]?.toString() || "",
            })),
        ...validityProps.map(
            propName => ({
                label: `${propName}`,
                id: "validity-" + propName,
                classExtensions: ["property", "property_" + propName],
                renderCell: (item: SourceItem) => item.props.validity?.[propName]?.[0]?.toString(),
            })),
        {
            label: "",
            id: "remove-button",
            classExtensions: ["remove_button"],
            renderCell: () => <CallbackButton
                callback={"remove-from-cart"}
                requireValidForm={false}
            ><label>Remove from cart</label></CallbackButton>
        }
    ];

    if (!cart.length) {
        return <div className="_download">
            <div className="_download_empty"></div>
        </div>
    }
    else {
        return <div className="_download">
            <div className="_download_buttons _download_buttons_before">
                <p className="_download_link"><a href={services.file.getDownloadLink(
                    siteState.site?.name || "",
                    cart,
                    wrapperfile,
                    indexfile,
                )}><button className="_download_button _download_button_before" type="button">Download</button></a></p>
            </div>
            <div className="_download_labels">
                {columns.map((column) => (
                    <p className={"_download_label " + column.classExtensions.map(ext => "_download_label_" + ext).join(" ")} key={column.id}>{column.label}</p>
                ))}
            </div>
            <div className="_download_items">
                {cart.map((item) => {
                    // Build unique key for this item
                    const key: string = item.value.toString()
                        + item.props.other.validityFilter || ""
                        // + Object.entries(item.props.validity).map(keyvalue => { return keyvalue[0] + ":" + keyvalue[1][0] }).join("-")
                        + Object.entries(item.props.system).map(keyvalue => { return keyvalue[0] + ":" + keyvalue[1][0] }).join("-");
                    return <div className="_download_item" key={key}>
                        {columns.map((column) => (
                            <div className={"_download_cell " + column.classExtensions.map(ext => "_download_cell_" + ext).join(" ")} key={column.id}>
                                <p className="_download_cell_label">{column.label}</p>
                                <p className="_download_cell_content">{column.renderCell(item)}</p>
                            </div>
                        ))}
                    </div>
                })}
                <div className="_download_buttons _download_buttons_after">
                    <p className="_download_link"><a href={services.file.getDownloadLink(
                        siteState.site?.name || "",
                        cart,
                        wrapperfile,
                        indexfile,
                    )}><button className="_download_button _download_button_after" type="button">Download</button></a></p>
                </div>
            </div>
        </div>
    }
};
